// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__jnOM3","page":"App_page__G3L86","skip":"App_skip__R3pHq"};